<div class="row m-0">
    <div class="col-12 pe-2 d-flex flex-wrap">
        @for (card of cards; track $index) {
            <div [ngClass]="'col-' + card.rows">
                <div [ngClass]="cards.length === 1 ? '' : $index === 0 ? 'pe-2' : 'ps-2'">
                    <div class="p-3 border border-dpgray300" style="border-radius: 12px;" [ngClass]="card.cardStyles.cssClass"
                        [style]="card.cardStyles.style" dropdown container="body" placement="right" (onShown)="cardFiltersOpen(card)">
                        <div dropdownToggle class="d-flex justify-content-between align-items-center p-0 m-0 dropdown-toogle" style="cursor: pointer;">
                            <div class="col-11 d-flex justify-content-between flex-fill">
                                <div [ngClass]="card.labelState ? 'col-9': 'col-12'" class="text-truncate">
                                    <h5 class="my-0 me-auto" style="display: inline;">
                                        <span class="widget-title fw-bold" [ngClass]="card.customStyles.cssClass"
                                            [style]="card.customStyles.style" [ngbTooltip]="card.tooltip | translate">{{card.title | translate}}</span>
                                    </h5>
                                    @if (card.subTitle) {
                                        <span class="widget-info ms-1" [ngClass]="card.customStyles.cssClass"
                                            [style]="card.customStyles.style" [ngbTooltip]="card.subTitle | translate">- {{card.subTitle | translate}}</span>
                                    }
                                </div>
                                @if (card.labelState) {
                                    <div class="col-3 px-3 text-truncate" [ngbTooltip]="card.labelState | translate">
                                        <span class="widget-status-label ms-1" >{{'cards.status' | translate}}:</span>
                                        <span class="badge rounded-pill fw-normal border ms-2" [ngClass]="'badge-' + card.stateClass.cssClass">{{card.labelState | translate}}</span>
                                    </div>
                                }
                            </div>
                            <div class="col-0">
                                <div class="btn pe-0">
                                    <span [ngbTooltip]="card.filtersOptionTooltip | translate">
                                        <fa-icon [icon]="faEllipsisVertical" size="lg" class="text-dpprimary"></fa-icon>
                                    </span>
                                </div>
                                <ul *dropdownMenu class="dropdown-menu" style="min-width: 390px; left: auto; right: -19px;">
                                    @if (card.filtersHeader) {
                                        <h6 class="dropdown-header">{{card.filtersHeader | translate}}</h6>
                                    }
                                    @for (filter of card.filters; track $index) {
                                        <li class="dropdown-item" [ngClass]="{'active': filter.active}"
                                            [ngStyle]="filter.type === cardFilerOptionType.DgeFilters ? {'border-top': '1px solid var(--dplight1)'} : {}"
                                            style="cursor: pointer;" (click)="clickFilter(filter, card)">
                                            @switch (filter.type) {
                                                @case (cardFilerOptionType.Label) {
                                                    <span class="text-dpdark" [ngbTooltip]="filter.tooltip | translate">{{filter.title | translate}}</span>
                                                }
                                                @case (cardFilerOptionType.DgeFilters) {
                                                    <div class="d-flex justify-content-between align-items-baseline p-0 m-0">
                                                        <div class="text-truncate">
                                                            <h5 class="my-0 me-auto text-dpblack">
                                                                <span class="text-dpblack" style="font-weight: bold;" [ngbTooltip]="filter.tooltip | translate">{{filter.title | translate}}</span>
                                                            </h5>
                                                            <span class="text-dpdark" [ngbTooltip]="filter.subTitle | translate">{{filter.subTitle | translate}}</span>
                                                        </div>
                                                        <div class="ps-3">
                                                            @if (filter.labelState) {
                                                                <fa-icon [icon]="faCircle" size="sm" [ngClass]="'text-' + filter.stateClass.cssClass" [ngbTooltip]="filter.labelState | translate"></fa-icon>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            }
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>